import React from "react";

import { CloseButton } from "../Button";

import { StyledTag } from "./ClosableTag.styles";
import { TagProps } from "./Tag.styles";

export interface ClosableTagProps extends TagProps {
  onClose: () => void;
  children: React.ReactNode;
}

export const ClosableTag = ({
  variant = "snow",
  onClose,
  children,
  ...props
}: ClosableTagProps) => {
  return (
    <StyledTag {...props} variant={variant}>
      {children}
      <CloseButton onClick={onClose} />
    </StyledTag>
  );
};
